import { useCardSurface } from '@littlebird/action-cards-view/react';
import { createContext, useContext } from 'react';

import type { Gap } from '../tokens';

const ObjectContext = createContext(false);

export const ObjectProvider = ObjectContext.Provider;

export const useInObject = () => useContext(ObjectContext);

// The object's own gap, seen only by its direct child Columns
const ObjectGapContext = createContext<Gap | undefined>(undefined);

export const ObjectGapProvider = ObjectGapContext.Provider;

export const useObjectGap = () => useContext(ObjectGapContext);

// True below a Column with `dimmed`, which already fades everything it holds
const DimmedContext = createContext(false);

export const DimmedProvider = DimmedContext.Provider;

export const useInDimmedObject = () => useContext(DimmedContext);

// An empty optional pill inside the object draws as a ghost, except on the phone's
// home preview, which leaves empty fields out
export const useGhostPills = () => {
  const inObject = useInObject();
  const surface = useCardSurface();
  return inObject && surface !== 'mobile_home';
};

// A divided Column's hairlines and a flush Column's section padding, seen by its
// children so Recipients can split its own rows the same way
export interface SectionsLayout {
  divided: boolean;
  flush: boolean;
}

const SectionsContext = createContext<SectionsLayout>({
  divided: false,
  flush: false,
});

export const SectionsProvider = SectionsContext.Provider;

export const useSectionsLayout = () => useContext(SectionsContext);
